module.exports = __webpack_public_path__ + "static/runners2-ff2d0dae8db2776f7826267e70ad6ffd.jpg";